// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"488":"13e9381a2bf164fbd80c","532":"8bbf4a81c065a9b9699d","574":"317c4700bc9cbe34891f","592":"44dbe3515a192d1e5e9a","736":"1ad56a82cd58abf093a3"}[chunkId] + ".js";
};